<template>
    <v-layout row wrap>
        <v-container>

            <v-flex class="admin">
                <v-flex>
                    <h2> ADMIN</h2>
                    <div class="risquinho"></div>
                </v-flex>

                <v-snackbar
                    v-model="snackbar" right top :timeout="timeout"
                > 
                    {{ text }}
                    <v-btn color="error" flat @click="snackbar = false" >
                        Fechar
                    </v-btn>
                </v-snackbar>



                <v-form>
                    <b-alert
                        :show="dismissCountDown"
                        dismissible
                        variant="danger"
                        @dismissed="dismissCountDown=0"
                        @dismiss-count-down="countDownChanged"
                    >
                        Não foi possível salvar o post...
                    </b-alert>

                    <v-text-field label="Título" class="title" v-model="post.title">
                    </v-text-field>

                    <div>
                        <picture-input  class="imgUpload"
                            ref="pictureInput" 
                            @change="onChange" 
                            height="150" 
                            :width="window.width"
                            margin="16" 
                            accept="image/jpeg,image/png" 
                            :zIndex='-1'
                            :crop="false"
                            :autoToggleAspectRatio="true"
                            :removable="true"
                            :customStrings="{
                                upload: '<h1>Falha no upload</h1>',
                                drag: 'Adicionar Imagem',
                                change: 'Alterar',
                                remove: 'Remover',
                                fileSize: 'Imagem grande demais. Tamanho máximo: 10MB',
                                fileType: 'Esse tipo de arquivo não é suportado'
                            }">
                        </picture-input>
                    </div>


                    <ckeditor :editor="editor" v-model="post.content" :config="editorConfig"></ckeditor>

                    <v-btn v-if="id != null" :loading="!refreshLoaded" color="secondary" @click.prevent="update(id)">Atualizar</v-btn>
                    <v-btn v-else :loading="!sendLoaded" color="secondary" @click.prevent="save">Enviar</v-btn>
                    <v-btn @click.prevent="clear">Limpar</v-btn>

                </v-form>

                <hr>

                
                <v-layout justify-space-around>
                    <v-flex v-if="loadedOnce">
                        <div v-for="(post, id) in posts" :key="id" class="post" >
                                <v-card  class="round-card">

                                    <v-card-title primary-title>
                                        <div>
                                            <div class="headline"> {{post[1].title}} </div> 
                                            <span class="grey--text"> {{post[1].date}} </span>
                                        </div>
                                    </v-card-title>

                                    <v-img class = "post-img {
                                        max-height: 100%;
                                        object-fit: contain;
                                    }   " :src="post[1].img" :max-height="500"></v-img>

                                    <v-card-text>
                                        <span v-html="post[1].content"></span> <br>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-btn @click.prevent="edit(post[0], post[1])">Editar</v-btn>
                                        <v-btn @click.prevent="del(post[0])">Excluir</v-btn>
                                        
                                    </v-card-actions>
                                </v-card>
                            </div>
                    </v-flex>

                </v-layout>

                <v-flex  class="center-progress" v-if="!postsLoaded" xs12 >
                    <v-progress-circular class="mx-auto" 
                    indeterminate
                    color="secondary"
                    ></v-progress-circular>
                </v-flex>
            </v-flex>
        </v-container>
    </v-layout>
</template>

<script>
import base from '../plugins/firebase'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PictureInput from 'vue-picture-input'


export default {
    components: {
        PictureInput
    },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                // toolbar: ['heading', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                height:200
            },

            snackbar: false,
            timeout: 3000,
            text: '',    

            posts: [],
            ref: base.database().ref("posts"),
            postOffset: 0,

            post: {
                title: '',
                content: '',
                img: ''
            },

            window: {
                width: 0,
                height: 0
            },

            id: null,

            dismissSecs: 5,
            dismissCountDown: 0,

            postsLoaded: false,
            loadedOnce: false,
            sendLoaded: true,
            refreshLoaded: true,
            scrolledToBottom: false

        }
    },

    created(){
        this.get()
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },

    watch: {
        scrolledToBottom: function () {
            if (this.scrolledToBottom && this.postsLoaded && this.loadedOnce){
                this.get();
            }
        }
    },
    mounted () {
  	    this.scroll()
    },
    methods: {
        scroll () {
            window.onscroll = () => {
                let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

                if (bottomOfWindow) {
                    this.scrolledToBottom = true 
                }
            }
        },

        save() {
            var current_datetime = new Date()
            var formatted_date = current_datetime.toLocaleString()

            if(this.post.title == ''){
                this.text = 'Publicação sem título'
                this.snackbar = true
                return;
            }
            
            if(this.post.img == ''){
                this.text = 'É necessário adicionar imagem à publicação'
                this.snackbar = true
                return;
            }
            if(this.post.content == 'null'){
                this.text = 'Publicação sem conteúdo'
                this.snackbar = true
                return;
            }

            this.sendLoaded = false

            try {
                this.ref.push().set({
                    title: this.post.title,
                    content: this.post.content,
                    img: this.post.img,
                    date: formatted_date 
    
                }).then(res => {
                    this.clear()
                    this.get()
    
                    this.sendLoaded = true
                }, err => {
                    this.text = 'Erro ao enviar publicação'
                    this.snackbar = true
    
                    
                })
                
            } catch (error) {
                this.text = 'Imagem maior que o tamanho máximo permitido'
                this.snackbar = true

                this.sendLoaded = true
            }
        },

        update() {
            this.refreshLoaded = false
            this.ref.child(this.id).set(this.post).then( res => {
                this.get()
                this.clear()
            }, err => {
                this.text = 'Erro ao atualizar publicação'
                this.snackbar = true

                this.refreshLoaded = true
            })

        },

        edit(key, post) {
            this.post = {...post}
            this.id = key

            window.scrollTo(0,0);
        },

        clear() {
            this.post = {title: '', content: '', img: ''}
            this.id = null
            this.removeImage()
        },

        get() {
            this.postsLoaded = false
            this.ref.orderByKey().limitToLast(5 + this.postOffset).once('value')
            .then(snapshot => {
                var result = snapshot.val()
                if(result != null){
                    this.posts = Object.entries(result).reverse()
                }
                else {
                    this.posts = []
                }

                this.postsLoaded = true
                this.loadedOnce = true
                this.postOffset += 3;
                this.scrolledToBottom = false
            })
        },

        del(key) {
            this.ref.child(key).remove( err => {
                this.get()
            })
        },

        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },

        showAlert() {
            this.dismissCountDown = this.dismissSecs
        },


        onChange () {
            if (this.$refs.pictureInput.image) {
                this.post.img = this.$refs.pictureInput.image;
            } 
        },

        removeImage () {
            this.$refs.pictureInput.$refs.fileInput.value = ''
            this.$refs.pictureInput.$refs.fileInput.type = ''
            this.$refs.pictureInput.$refs.fileInput.type = 'file'
            this.$refs.pictureInput.fileName = ''
            this.$refs.pictureInput.fileType = ''
            this.$refs.pictureInput.fileSize = 0
            this.$refs.pictureInput.fileModified = 0
            this.$refs.pictureInput.imageSelected = false
            this.$refs.pictureInput.image = ''
            this.$refs.pictureInput.file = null
            this.$refs.pictureInput.imageObject = null
            this.$refs.pictureInput.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)'
            this.$refs.pictureInput.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio
        },

        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }

    }
}
</script>

<style >
.picture-inner-text{
    font-size: 21px !important;
    color: #D4D4D4 ;
}

.imgUpload {
    padding-bottom: 20px;
}

.post-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}   

.post {  
    padding-bottom: 20px;
}

.imgUpload .btn-primary{
    background-color: #6ba348;
    border-color: #6ba348;
}

.imgUpload .btn-secondary {
    color: rgba(0,0,0,0.87);
    background-color: #f5f5f5 !important;
    border-color: #f5f5f5 !important;
}
</style>
